import React from "react";
import { Table } from "semantic-ui-react";

function Fila(props) {
  const handleClick = () => props.handleClick(props.id);

  return (
    <Table.Row onClick={handleClick} className="aristas-pointer">
      <Table.Cell content={props.nombre} />
      <Table.Cell content={props.poblacion} />
      <Table.Cell content={props.provincia} textAlign="center" />
      <Table.Cell content={props.num} textAlign="center" />
    </Table.Row>
  );
}

export default Fila;



// WEBPACK FOOTER //
// ./src/pages/inscripcionesConfirmadas/tablaInscripciones/Fila.jsx